exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 992px) {\n  aside {\n    display: none; }\n  .side-nav {\n    margin-top: 8px; } }\n\n.logo {\n  width: 64px;\n  height: 64px; }\n\n.nav-button-text {\n  width: 64px;\n  overflow: hidden;\n  margin: 0px -16px;\n  text-align: center;\n  color: #4C4E52;\n  font-size: 0.7em;\n  margin-top: 18px;\n  position: absolute;\n  padding: 0;\n  top: 10px;\n  line-height: 2.5; }\n\n.nav-button-icon {\n  color: #4C4E52 !important; }\n\n.nav-button-link {\n  position: relative; }\n\nul.side-nav.leftside-navigation li:not(.no-padding).active {\n  background-color: rgba(0, 0, 0, 0.08); }\n\n#slide-out li a i {\n  line-height: 2; }\n\n.side-nav li > a {\n  height: 55px; }\n\n.help_button {\n  position: absolute;\n  bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/navigation-questionnaire/navigation-questionnaire.component.scss
// module id = ../../../../../src/app/components/navigation-questionnaire/navigation-questionnaire.component.scss
// module chunks = main